import React, { useState } from "react";
import { motion } from "framer-motion";
import { galleryItems } from "../data/content";

export default function Gallery() {
  const [filter, setFilter] = useState("all");
  const items = galleryItems.filter((i) => filter === "all" || i.type === filter);

  return (
    <main className="bg-ink min-h-screen pt-32 pb-16">
      <div className="max-w-6xl mx-auto px-6">
        <p className="text-brand-500 font-medium mb-2">Our work</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-neutral-900" data-testid="gallery-heading">
          Project Gallery
        </h1>
        <p className="text-neutral-500 mt-3 max-w-2xl">
          Explore our high-quality construction projects, modern invisible safety grill
          installations, and durable structural renovations.
        </p>

        <div className="flex gap-2 mt-8">
          {[["all", "All Projects"], ["image", "Images"], ["video", "Videos"]].map(([id, label]) => (
            <button key={id} onClick={() => setFilter(id)} data-testid={`gallery-filter-${id}`}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${
                filter === id ? "bg-brand-500 text-white border-brand-500" : "border-neutral-300 text-neutral-600 hover:border-neutral-500"
              }`}>
              {label}
            </button>
          ))}
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 mt-10">
          {items.map((item, i) => (
            <motion.div
              key={item.src}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.05 }}
              className="group relative rounded-2xl overflow-hidden bg-surface border border-neutral-200 shadow-card"
              data-testid={`gallery-item-${i}`}
            >
              <div className="h-60 overflow-hidden bg-neutral-100">
                {item.type === "image" ? (
                  <img src={item.src} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                ) : (
                  <video src={item.src} className="w-full h-full object-cover" muted loop playsInline
                    onMouseOver={(e) => e.target.play()} onMouseOut={(e) => e.target.pause()} controls />
                )}
              </div>
              <div className="p-4">
                <span className="text-xs font-semibold text-brand-500">{item.tag}</span>
                <h3 className="font-semibold text-neutral-900">{item.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </main>
  );
}
